.dr{aspect-ratio:1/1;}